export enum TipoRespostaEnum {
  EscolhaUma = 0,
  MultiplaEscolha = 1,
  TextoSimples = 2,
  TextoGrande = 3,
  Combo = 4,
  Data = 5,
  Inteiro = 6,
  Decimal = 7,
  Divisor = 8,
  Arquivo = 9
}
